export default {
  countriesList: [],
  entityStatesList: [],
  bankStatesList: [],
  signatoryStatesList: [],
};
